import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { pobDataModel } from '../../model';
import * as $ from 'jquery';
import { Subscription } from 'rxjs'; 
@Component({
    selector: 'app-daywisecall',
    template: require('./daywisecall.component.html'),
    styles: []
})
export class DayWiseCallComponent implements OnInit {
    formgroup: FormGroup;
    EmpDayPlanDetails: any;
    private columnDefs;
    private rowHeight;
    api: any;
    busy: Subscription;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    private detailCellRendererParams;
    currentMonth: any;

    staffTypes: any;
    staff: any;
    designation: any;
    currentDate: any;
    firstDate: string;
    lastDate: string;
    stateList: any = [];
    headQuarterList: any = [];
    empName: any = [];  
    token:any;  
    @ViewChild('close') public modal: ElementRef;
    pobDataModel: pobDataModel = new pobDataModel();

    static parameters = [ApiService];
    constructor(private apiService: ApiService) {
        this.columnDefs = [
            { headerName: 'S.No.', valueGetter: "node.rowIndex + 1", width: 80 },
            { headerName: 'Employee Name', field: "EmployeeName", suppressFilter: true, cellRenderer: 'agGroupCellRenderer' },
            { headerName: 'Employee Code', field: "EmployeeCode" },
            { headerName: 'Manager', field: "Manager" },
            { headerName: 'State', field: "StateName" },
            { headerName: 'HQ', field: "HQName" },
            { headerName: 'Designation', field: "Designation" },
            { headerName: 'Last Reported', field: "Last_Reported_Date" },
        ];

        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
        this.detailCellRendererParams = {
            detailGridOptions: {
                rowSelection: 'multiple',
                suppressRowClickSelection: true,
                enableRangeSelection: true,
                pagination: false,
                paginationAutoPageSize: true,
                columnDefs: [
                    { headerName: 'Date', field: 'Date' },
                    { headerName: 'Working Type', field: 'Working_Type' },
                    { headerName: 'Retailer Call', field: 'Retailer_Call' },
                    { headerName: 'Stk Call', field: 'Stk_Call' },
                    { headerName: 'GPS km', field: 'GPSKM' },
                    { headerName: 'Route Name', field: 'Route_Name', minWidth: 250 },
                    { headerName: 'Area Name', field: 'Area_Name', minWidth: 250 }
                ],
                rowHeight: 50,
                headerHeight: 50,
                defaultColDef: {
                    sortable: true,
                    flex: 1,
                },
            },
            getDetailRowData: function (params) {
                console.log('params', params.data.details);
                params.successCallback(params.data.details);
            },
        };
    }

    onFirstDataRendered(params) {
        setTimeout(function () {
            params.api.getDisplayedRowAtIndex(1).setExpanded(false);
        }, 0);
    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        var date = new Date();
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        this.firstDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        this.lastDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        console.log('firstDate ', this.firstDate, this.lastDate);
        this.daywisecall_Form.controls['fromDate'].setValue(
            this.firstDate
        );
        this.daywisecall_Form.controls['toDate'].setValue(
            this.lastDate
        );

        this.pobDataModel.stateId = 0;
        this.pobDataModel.hq = 0;
        this.pobDataModel.employeeCode = "0";
        this.pobDataModel.stafftype = "0";
        this.formgroup = this.daywisecall_Form;
        this.getState();
        this.getHeadQuarterList();
        this.getEmployee();
        this.getStaffTypes();
        $('#filter-option').trigger('click');
    }

    daywisecall_Form = new FormGroup({
        fromDate: new FormControl('', [Validators.required]),
        toDate: new FormControl('', [Validators.required]),
        state: new FormControl('', [Validators.required]),
        hq: new FormControl('', [Validators.required]),
        employee: new FormControl('', [Validators.required]),
        staffType: new FormControl('', [Validators.required]),


    });

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
    }

    getState() {
        this.apiService.getState().subscribe((res: any) => {
            this.stateList = res.data;
        })
    }

    getHeadQuarterList() {
        this.apiService.getHeadQuarterList().subscribe((res: any) => {
            this.headQuarterList = res.data;
        })
    }

    getEmployee() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empName = res.data;
        })
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'DayWiseCallDetails' });
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
    }

    getStaffTypes() {
        this.apiService.getStaffTypes().subscribe((res: any) => {
            this.staffTypes = res.data;
        });
    }

    filterData() {
        console.log(this.formgroup.value);
        var queryData = {
            EmployeeID: this.formgroup.value.employee,
            hq: this.formgroup.value.hq,
            staffType: this.formgroup.value.staffType,
            state: this.formgroup.value.state,
            fromDate: this.formgroup.value.fromDate,
            toDate: this.formgroup.value.toDate,
            LoginId:this.token.id,
        }
        var parent = this;
        console.log(queryData);
        //this.api.showLoadingOverlay();
       this.busy = this.apiService.GetDayWiseCallDetails(queryData)
        .subscribe((res: any) => {
            //this.api.showNoRowsOverlay();
            var EmpDetails = res.EmpDetails;
            parent.EmpDayPlanDetails = EmpDetails;
            var EmpDayPlanDetails = res.EmpDayPlanDetails;
            console.log('EmpDetails', EmpDetails);
            console.log('EmpDayPlanDetails', EmpDayPlanDetails);
            EmpDetails.filter((el, index) => {
                parent.EmpDayPlanDetails[index].details =  EmpDayPlanDetails.filter(data => { return el.EmpId == data.EmpId});
            });
        })
        this.modal.nativeElement.click();
    }
}
